import PropTypes from 'prop-types';

const reactNodeType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);

export default reactNodeType;
